(() => {
  const loadRecommendations = (el) => {
    if (!el || !el.dataset.url || el.dataset.loaded === 'true') return;
    el.dataset.loaded = 'true';
    fetch(el.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const fresh = html.querySelector('[data-yl-reco]');
        if (fresh && fresh.innerHTML.trim().length) {
          el.innerHTML = fresh.innerHTML;
        }
      })
      .catch((error) => console.error('[yl-reco]', error));
  };

  const boot = () => {
    document.querySelectorAll('[data-yl-reco]').forEach((el) => {
      setTimeout(() => loadRecommendations(el), 1200);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
